<template lang="html">

  <section class="blog column-center">

    <div class="blog-text">

      <h2 class="title -intro -black" v-html="$t('blog.titulo')"></h2>

      <h3 class="subtitle-intro">
        <a href="https://blog.aldonzagourmet.com/" target="_blank"><span v-html="$t('blog.subtitulo')"></span></a>

      </h3>

    </div>


    <div class="listado-noticias row-center" v-if="!!noticias">


      <template v-for="(noticia, key) in noticias[bloglang]">

        <div class="wrapper-noticia-el">

          <article class="noticia-el column-center"
          :style="`background:url(${(noticia.better_featured_image) ? noticia.better_featured_image.source_url : ''}) center/cover no-repeat`">

          <h3 class="title" :title="noticia.title.rendered" v-html="$options.filters.shortTitle(noticia.title.rendered)"></h3>

          <a :href="noticia.link" class="enlace-cover" target="_blank" :title="noticia.title.rendered"></a>  

          <a :href="noticia.link" class="btn" target="_blank" :title="noticia.title.rendered">
            <span>{{$t('blog.boton')}}</span>
          </a>  

        </article>

      </div>

    </template>

  </div>

  <div class="row-center fake-list" v-else>
    <article class="noticia-el -fake" v-for="n in 4"></article>
  </div>

</section>

</template>

<script lang="js">

  import {mapGetters, mapActions} from 'vuex';

  export default  {
    name: 'blog',
    props: [],
    mounted() {

      let otherlangs = ['ja','ko','ru'];
      this.requestNoticias();
      if(otherlangs.includes(this.lang)){
        this.bloglang = 'en';
      }else{
        this.bloglang = this.lang;
      }
    },
    data() {
      return {
        bloglang : ''
      }
    },
    methods: {
      ...mapActions(['requestNoticias'])
    },
    computed: {
      ...mapGetters({
        noticias : 'getNoticias',
        lang : 'getLanguage'
      }),
    },
    filters : {
      shortText : function(value){

        let max;

        if(window.innerWidth >= 1400){
          max = 200;
        }else if(window.innerWidth >= 1250 && window.innerWidth < 1400){
          max = 200;
        }else if(window.innerWidth < 1250){
          max = 140;
        }

        let shortText = value.substring(0, max);

        if(!!value.charAt(max)){
          shortText += "...";
        }

        return shortText;
      },
      shortTitle : function(value){

        const max = 42;

        let shortText = value.substring(0, max);

        if(!!value.charAt(max)){
          shortText += "...";
        }

        return shortText;

      }
    }
  }
</script>

<style scoped lang="scss">

  @import "@/assets/css/colors.scss";

  .blog {
    height: 100%;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    background: white;
    width: 100%;
  }

  .blog-text > .title{
    font-size: 36px;
    padding-bottom: 20px;

  }

  .blog-text > .title::before{
    top: auto;
    bottom: 0;
  }



  .subtitle-intro{
    color: #000;
  }

  .listado-noticias{
    margin-top: 30px;
    overflow: hidden;
    width: 100%;
  }

  .vive-aldonza .listado-noticias,
  .contenedor-blog .listado-noticias{
    margin-top: 60px;
  }


  .wrapper-noticia-el{
    transform: translateY(100%);
    transition: 1s;
    width: 25%;


    &:nth-child(5),
    &:nth-child(6){
      display: none;
    }

  }

  @for $i from 1 through 10{
    .wrapper-noticia-el:nth-child(#{$i}){
      transition:all 1s ease-out #{$i / 5 + .5}s;
    }
  }

  .launched{
    .listado-noticias{
      transform: translateX(0);
    }

    .subtitle-intro span{
      transition-delay: 1.5s;
    }

    .wrapper-noticia-el{
      transform: translateY(0);
    }

  }


  .noticia-el{
    width: 100%;
    height: 500px;
    position: relative;
    padding: 80px 25px;
    justify-content: row-center;
    -webkit-justify-content: row-center;
    transform: translateY(100%);
    transition: .6s;
    will-change:transform;
    transition-timing-function: ease-in-out;
    z-index: 8;
    &:hover{
      transform:translateY(0);
    }

    .enlace-cover{
      background: -moz-linear-gradient(top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 100%); /* FF3.6-15 */
      background: -webkit-linear-gradient(top, rgba(0,0,0,0.7) 0%,rgba(0,0,0,0.3) 100%); /* Chrome10-25,Safari5.1-6 */
      background: linear-gradient(to bottom, rgba(0,0,0,0.7) 0%,rgba(0,0,0,0.3) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
      filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#b3000000', endColorstr='#4d000000',GradientType=0 ); /* IE6-9 */
    }

    .title{
      font-size: 2.3vw;
      line-height: 2.5vw;
      letter-spacing: 3px;
      position: relative;
      z-index: 6;
      pointer-events: none;
      font-family: 'pennellinoregular';
      text-align: center;
      &::before{
        left:50%;
        margin-left: -22.5px;
      }
    }



    p{
      font-size: 14px;
      line-height: 24px;
      text-align: justify;
      color: white;
      position: relative;
      z-index: 6;
      pointer-events: none;
    }

    .btn{
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 40px;
      width: 100%;
      max-width: 230px;
      opacity: 0;
      transition: 1s;
      transition-timing-function: ease-in-out;
    }

    &:hover .btn{
      opacity: 1;
    }

    &.-fake{
      -webkit-animation: GrisAnimation 2s ease infinite;
      -moz-animation: GrisAnimation 2s ease infinite;
      animation: GrisAnimation 2s ease infinite;
      background: linear-gradient(274deg, $warm-grey-40, white);
      background-size: 400% 400%; 
    }
  }

  .launched .noticia-el{
    transform: translateY(60px);
    /*transition-delay: 3s;*/
  }

  .launched .noticia-el:hover{
   transform: translateY(0px); 
   transition-delay: 0s;
 }

 .fake-list{
  width: 100%;
  overflow: hidden;

  .noticia-el{
    width: 25%;
  }
}

@media screen and (max-width: 1150px){
  .wrapper-noticia-el{
    width: 50%;
    height: 300px;
  }

  .launched .noticia-el{
    padding: 40px 20px;
    width: 100%;
    height: 100%;
    transform: translateY(0);
    .btn{
      max-width: 150px;
    }
  }
  


}

@media screen and (max-width: 1024px){
  .noticia-el{

    padding: 40px 20px;
    width: 33.333333%;

    .title{
      font-size: 36px;
      line-height: 40px;
    }

    .btn{
      display: none;
    }

    &:nth-child(5),
    &:nth-child(6){
      display:flex;
    }
  }

  .listado-noticias{
    background: $plum;
  }
}

@media screen and (max-width: 800px){
  .noticia-el{
    width: 50%;

    &:nth-child(5),
    &:nth-child(6){
      display: none;
    }
  }
}


@media screen and (max-width: 767px){
  .wrapper-noticia-el{
    width: 100%;
  }
  .noticia-el{
    width: 100%;
  }

  .title.-intro{
    height: 120px;
  }

  .title span{
    height: 50px;
  }
}

@media screen and (max-width: 600px){
  .vive-aldonza .listado-noticias,
  .contenedor-blog .listado-noticias{
    margin-top: 25px;
  }
}



</style>



// WEBPACK FOOTER //
// src/components/parts/blog.vue